import React from 'react';

import {Link} from 'react-router-dom';
import handBookPdf from 'assets/Handbok Dysmate-Y SE version 1.0_compressed.pdf';
import handBookImage from 'assets/Handbok Dysmate-Y SE full version.png';
import dysmateReportPdf from 'assets/Swedish Dysmate final report_compressed (1).pdf';
import dysmateReportImage from 'assets/Front Dysmate-Y report.png';
import bokmolResourceBookletImage from '../../../../assets/1-min.png';
import bokmolResourceBookletPdf from '../../../../assets/Resurshäfte SE full version.pdf';

import './styles.scss';
import strings from 'utils/strings';

class HandBook extends React.Component {
	constructor() {
		super();
		this.state = {};
	}

	render() {
		const hasLocation =
			this.props.location !== 'undefined' ? this.props.location : null;

		const hasPathName = hasLocation ? hasLocation.pathname : null;
		const isLibraryPath =
			hasLocation && this.props.location.pathname === '/bibliotek'
				? true
				: null;
		return (
			<div
				className={
					!isLibraryPath
						? 'lit-handbook-main'
						: 'lit-handbook-main_library-style'
				}
			>
				{hasPathName ? (
					<h1 className="lit-handbook-title">
						{strings.formatString(strings.handbooktitle, <></>)}
					</h1>
				) : (
					<></>
				)}
				{isLibraryPath && (
					<>
						<div className="lit-library-content-wrapper">
							<div className="lit-library-content-wrapper__row">
								<a
									href={bokmolResourceBookletPdf}
									target="_blank"
								>
									<img
										className="lit-lib-handbook-img"
										src={bokmolResourceBookletImage}
									/>
								</a>
								<div className="lit-lib-handbook-title-link">
									<Link
										to={bokmolResourceBookletPdf}
										target="_blank"
										rel="noopener noreferrer"
									>
										Ressurshefte Dysmate
									</Link>
								</div>
							</div>
							<div className="lit-library-content-wrapper__row">
								<a href={handBookPdf} target="_blank">
									<img
										className="lit-lib-handbook-img"
										src={handBookImage}
									/>
								</a>
								<div className="lit-lib-handbook-title-link">
									<Link
										to={handBookPdf}
										target="_blank"
										rel="noopener noreferrer"
									>
										Handbok Dysmate
									</Link>
								</div>
							</div>
							<div className="lit-library-content-wrapper__row">
								<a href={dysmateReportPdf} target="_blank">
									<img
										className="lit-lib-handbook-img"
										src={dysmateReportImage}
									/>
								</a>
								<div className="lit-lib-handbook-title-link">
									<Link
										to={dysmateReportPdf}
										target="_blank"
										rel="noopener noreferrer"
									>
										Rapport Dysmate
									</Link>
								</div>
							</div>
						</div>
					</>
				)}
				{!isLibraryPath && (
					<>
						<span>
							<a href={handBookPdf} target="_blank">
								<img
									className="lit-handbook-img"
									src={handBookImage}
								/>
							</a>
						</span>
						<span className="lit-handbook-title-link">
							<Link
								to={handBookPdf}
								target="_blank"
								rel="noopener noreferrer"
							>
								Handbok Dysmate
							</Link>
						</span>
					</>
				)}{' '}
				{/* {isLibraryPath && (
					<div className="lit-library-content-wrapper">
						<div className="lit-library-content-wrapper__row">
							<a href={handBookPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={HandBookImage}
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={handBookPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									Håndbok Dysmate
								</Link>
							</div>
						</div>
						<div className="lit-library-content-wrapper__row">
							<a href={HandbookConfirmationPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={HandbookConfirmationImg}
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={HandbookConfirmationPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									Bekreftelse på dysleksi
								</Link>
							</div>
						</div>
					</div>
				)} */}
			</div>
		);
	}
}
export default HandBook;
